import 'commons/utils/yup'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import MainProvider from 'commons/providers/MainProvider'
import UserProvider from 'commons/contexts/UserContext/UserProvider'
import Main from 'pages/Main'

function App() {
  return (
    <MainProvider>
      <BrowserRouter>
        <UserProvider>
          <Main />
        </UserProvider>
      </BrowserRouter>
    </MainProvider>
  )
}

export default App
